import {useUser} from '../../context/UserProvider'

export default useUser